import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { finalize } from 'rxjs';
import * as i1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import * as i2 from '@angular/platform-browser';
import * as i3 from 'abs-ngx-library/src/lib/core';

const _c0$1 = (a0, a1) => ({ color: a0, fontSize: a1 });
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clipCoupon(ctx_r1.data)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("id", "couponAddBtn", ctx_r1.data.offerId, "");
    i0.ɵɵattribute("aria-describedby", "coupon-price-" + ctx_r1.data.offerId + " " + "coupon-title-" + ctx_r1.data.offerId + " " + "coupon-description-" + ctx_r1.data.offerId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.data == null ? null : ctx_r1.data.deleted) ? ctx_r1.behavioralOfferAttrs && (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText) ? ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText : "Add to List" : "Clip Coupon", " ");
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 3);
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementStart(3, "span", 5)(4, "span", 6);
    i0.ɵɵtext(5, "Coupon has already been ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "Clipped");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-describedby", "coupon-price-" + ctx_r1.data.offerId + " " + "coupon-title-" + ctx_r1.data.offerId + " " + "coupon-description-" + ctx_r1.data.offerId);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clipCoupon(ctx_r1.data)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("id", "couponAddBtn", ctx_r1.data.offerId, "");
    i0.ɵɵattribute("aria-describedby", "coupon-price-" + ctx_r1.data.offerId + " " + "coupon-title-" + ctx_r1.data.offerId + " " + "coupon-description-" + ctx_r1.data.offerId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.data == null ? null : ctx_r1.data.deleted) ? ctx_r1.behavioralOfferAttrs && (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText) ? ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText : "Add to List" : "Clip Coupon", " ");
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_1_Template, 2, 4, "button", 1)(2, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_div_2_Template, 7, 1, "div", 0)(3, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_button_3_Template, 2, 4, "button", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.data.status == "U");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.data.status == "C" && !(ctx_r1.data == null ? null : ctx_r1.data.deleted));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.data.status == "C" && (ctx_r1.data == null ? null : ctx_r1.data.deleted));
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 2);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clipCoupon(ctx_r1.data)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "couponAddBtn", ctx_r1.data.offerId, "");
    i0.ɵɵattribute("aria-describedby", "coupon-price-" + ctx_r1.data.offerId + " " + "coupon-title-" + ctx_r1.data.offerId + " " + "coupon-description-" + ctx_r1.data.offerId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((ctx_r1.data == null ? null : ctx_r1.data.deleted) ? ctx_r1.behavioralOfferAttrs && (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText) ? ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.addToMyListBtnText : "Add to List" : ctx_r1.startChallengeLabel);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_span_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16)(1, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_span_13_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.startShoppingLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_span_13_Template_a_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.startShoppingLink)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.startShoppingLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs.startShoppingText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "div", 8)(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 10);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 11);
    i0.ɵɵtext(8, "/\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 12);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵelement(12, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_span_13_Template, 3, 2, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r1.offerDataDisplay(ctx_r1.data == null ? null : ctx_r1.data.continuity).prefix, ":\u00A0");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.offerDataDisplay(ctx_r1.data == null ? null : ctx_r1.data.continuity).progressVal, "\u00A0");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r1.offerDataDisplay(ctx_r1.data == null ? null : ctx_r1.data.continuity).targetVal, "\u00A0");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(ctx_r1.getStyle(ctx_r1.data));
    i0.ɵɵattribute("aria-valuenow", ctx_r1.data == null ? null : ctx_r1.data.continuity.progressValue)("aria-valuemax", ctx_r1.data == null ? null : ctx_r1.data.continuity.targetValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFreshpassContinuityCoupon(ctx_r1.data));
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.grClipLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_6_Template_a_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.grClipLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.grClipLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.grClipButtonText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_7_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.ucaEmailOptInLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_7_Template_a_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.ucaEmailOptInLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.ucaEmailOptInLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.ucaEmailOptInButtonText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_8_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.ecomFulfillmentLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_8_Template_a_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.ecomFulfillmentLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.ecomFulfillmentLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.ecomFulfillmentButtonText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 20)(5, "span", 16);
    i0.ɵɵtemplate(6, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_6_Template, 2, 2, "a", 21)(7, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_7_Template, 2, 2, "a", 21)(8, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_a_8_Template, 2, 2, "a", 21);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.inProgressStatusText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.data == null ? null : ctx_r1.data.qualificationBehavior.trim().toLowerCase()) === (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.grClipTextOMS.trim().toLowerCase()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.data == null ? null : ctx_r1.data.qualificationBehavior.trim().toLowerCase()) === (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.ucaEmailOptInTextOMS.trim().toLowerCase()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.data == null ? null : ctx_r1.data.qualificationBehavior.trim().toLowerCase()) === (ctx_r1.behavioralOfferAttrs == null ? null : ctx_r1.behavioralOfferAttrs.ecomFulfillmentTextOMS.trim().toLowerCase()));
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_1_Template, 14, 8, "ng-container", 0)(2, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_ng_container_2_Template, 9, 4, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isContinuityCoupon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isBehaviorCoupon);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_9_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.myListLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_9_Template_a_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.myListLink)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.myListLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs.viewInMyListText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "a", 17);
    i0.ɵɵlistener("click", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_10_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.freshPassOfferLink)); })("keydown.enter", function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_10_Template_a_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.behavioralOfferAttrs.freshPassOfferLink)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r1.behavioralOfferAttrs.freshPassOfferLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.behavioralOfferAttrs.freshPassOfferText);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 23)(4, "g", 24)(5, "g", 25);
    i0.ɵɵelement(6, "polygon", 26);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "span", 27);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_9_Template, 3, 2, "div", 28)(10, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_div_10_Template, 3, 2, "div", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.challengeCompletedLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("fill", ctx_r1.challengeCompletedLabelColor);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(6, _c0$1, ctx_r1.challengeCompletedLabelColor, ctx_r1.fontSize));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.challengeCompletedLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFreshpassContinuityCoupon(ctx_r1.data));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFreshpassContinuityCoupon(ctx_r1.data));
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_1_Template, 3, 2, "ng-container", 0)(2, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_ng_container_2_Template, 11, 9, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isBonusPathCompleted);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isBonusPathCompleted);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_1_Template, 3, 4, "ng-container", 0)(2, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_ng_container_2_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isCouponClipped);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCouponClipped);
} }
function LoyaltyCardActionButtonsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_1_Template, 4, 3, "ng-container", 0)(2, LoyaltyCardActionButtonsComponent_ng_container_0_ng_container_2_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isBehaviourOrContinuityCoupon(ctx_r1.data));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isBehaviourOrContinuityCoupon(ctx_r1.data));
} }
const units = [
    {
        unit: "ITEM",
        usePrefix: "Purchased",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "ITEMS",
        usePrefix: "Purchased",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "AMOUNT",
        usePrefix: "Purchased",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "DOLLARS",
        usePrefix: "Purchased",
        valuePrefix: "$",
        valuePostFix: "",
    },
    {
        unit: "QUANTITY_PRICE",
        usePrefix: "Purchased",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "POUND",
        usePrefix: "Purchased",
        valuePostFix: "Lbs",
        valuePrefix: "",
    },
    {
        unit: "PER POUND",
        usePrefix: "Purchased",
        valuePostFix: "Lbs",
        valuePrefix: "",
    },
    {
        unit: "WEIGHT_VOLUME",
        usePrefix: "Quantity",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "WEIGHT/VOLUME",
        usePrefix: "Quantity",
        valuePrefix: "",
        valuePostFix: "",
    },
    {
        unit: "QUANTITY",
        usePrefix: "Quantity",
        valuePrefix: "",
        valuePostFix: "",
    },
];
class LoyaltyCardActionButtonsComponent {
    constructor() {
        this.cardType = "";
        this.continuityOfferType = "continuity";
        this.freshPassContinuityOffer = "IA FRESHPASS";
        this.behavioralOfferAttrs = {
            startChallengeButtonName: "Activate",
            challengeCompletedStatusText: "Bonus Path Completed",
            inProgressStatusText: "In Progress",
            grClipTextOMS: "GR Clip",
            ucaEmailOptInTextOMS: "UCA Email Opt In",
            ecomFulfillmentTextOMS: "ECOM Fulfillment",
            grClipButtonText: "Go to Grocery Rewards",
            ucaEmailOptInButtonText: "Go to Account Settings",
            ecomFulfillmentButtonText: "Go to My Cart",
            ucaEmailOptInLink: "/customer-account/communication-preference.html",
            ecomFulfillmentLink: "/",
            grClipLink: "/foru/rewards.html",
            addToMyListBtnText: "Add to List",
            viewInMyListText: "View in My List",
            myListLink: "/mylist.html",
            startShoppingText: "Start Shopping",
            startShoppingLink: "/",
            freshPassOfferText: "Redeem FreshPass offer",
            freshPassOfferLink: "/freshpass/manage/subscribe",
        };
        this.isBehaviorCoupon = false;
        this.isContinuityCoupon = false;
        this.isCouponClipped = false;
        this.isBonusPathCompleted = false;
        this.showLoadingCoupon = false;
        this.showBoxtop = false;
        this.challengeCompletedLabelColor = '#757575';
        this.fontSize = '12px';
        this.emitClippedCoupon = new EventEmitter();
        this.startChallengeLabel =
            window["SWY"].CONFIGSERVICE.nimbusConfig.couponActionTypes["SCC"];
        this.challengeCompletedLabel =
            window["SWY"].CONFIGSERVICE.nimbusConfig.couponActionTypes["CC"];
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (this.cardType === 'coupon') {
            this.checkOfferStatus();
        }
    }
    isBehaviourOrContinuityCoupon(coupon) {
        return coupon?.continuity || (coupon.qualificationBehavior && coupon.qualificationBehavior !== "");
    }
    isFreshpassContinuityCoupon(coupon) {
        let flag = false;
        if (coupon.continuity &&
            coupon.programSubType &&
            coupon.programSubType.trim().toLowerCase() ===
                this.freshPassContinuityOffer.trim().toLocaleLowerCase()) {
            flag = true;
        }
        return flag;
    }
    checkOfferStatus() {
        if ((this.data.status && this.data.status === "C") ||
            (!this.data.status && !this.data.deleted)) {
            this.isCouponClipped = true;
            if (this.data.continuity) {
                this.isBonusPathCompleted =
                    this.data.continuity.progressValue ===
                        this.data.continuity.targetValue;
                this.isContinuityCoupon = true;
                this.isBehaviorCoupon = false;
            }
            else if (this.data.qualificationBehavior &&
                this.data.qualificationBehavior !== "") {
                this.isBonusPathCompleted =
                    this.data.bonusPathStatus !== "" &&
                        this.data.bonusPathStatus.toLowerCase() !== "inprogress";
                this.isContinuityCoupon = false;
                this.isBehaviorCoupon = true;
            }
        }
        else if (this.data.status === "U" && !this.data.deleted) {
            this.isCouponClipped = false;
        }
    }
    navigateTo(offerChallegeLink) {
        this.showLoadingCoupon = true;
        window.location.pathname = offerChallegeLink;
    }
    offerDataDisplay(data) {
        let vals = {};
        if (data?.units) {
            const findIndexFromUnits = units.findIndex((u) => u.unit.toLowerCase() === data.units.toLowerCase());
            if (findIndexFromUnits >= 0) {
                const _unit = units[findIndexFromUnits];
                vals = {
                    prefix: _unit.usePrefix,
                    progressVal: _unit.valuePrefix
                        ? `${_unit.valuePrefix}${data.progressValue}`
                        : _unit.valuePostFix
                            ? `${data.progressValue}${_unit.valuePostFix}`
                            : data.progressValue,
                    targetVal: _unit.valuePrefix
                        ? `${_unit.valuePrefix}${data.targetValue}`
                        : _unit.valuePostFix
                            ? `${data.targetValue}${_unit.valuePostFix}`
                            : data.targetValue,
                };
            }
        }
        else {
            vals = {
                prefix: 'Transactions',
                progressVal: data.progressValue,
                targetVal: data.targetValue
            };
        }
        return vals;
    }
    clipCoupon(coupon) {
        this.emitClippedCoupon.emit(coupon);
    }
    getStyle(data) {
        const width = (data?.continuity.progressValue * 100) / data?.continuity.targetValue;
        const height = 'inherit';
        return `width: ${width}%; height: ${height}`;
    }
    static { this.ɵfac = function LoyaltyCardActionButtonsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyCardActionButtonsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoyaltyCardActionButtonsComponent, selectors: [["loyalty-card-action-buttons"]], inputs: { cardType: "cardType", data: "data" }, outputs: { emitClippedCoupon: "emitClippedCoupon" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["type", "button", "class", "btn btn-md btn-primary w-100 p-0", 3, "id", "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-md", "btn-primary", "w-100", "p-0", 3, "click", "id"], [1, "clipped"], [1, "clipped__checkmark", "svg-checkmark"], [1, "clipped__label"], [1, "sr-only"], [1, "d-flex", "flex-column"], ["role", "progressbar", 1, "progress-offer-status"], [1, "progress-msg"], [1, "pgs-lwrlmt"], [1, "limit-separator"], [1, "pgs-uprlmt"], [1, "progress", 2, "height", "6px"], ["role", "progressbar", "aria-valuemin", "0", 1, "progress-bar"], ["class", "behaviour-link body-text-xs ", 4, "ngIf"], [1, "behaviour-link", "body-text-xs"], ["role", "link", 1, "links__action", "links__action__inline", "underline", 3, "click", "keydown.enter", "href"], [1, "progress-behaviour-status", "d-flex", "flex-column"], [1, "body-text-xs"], [1, "behaviour-link-container"], ["class", "links__action links__action__inline underline", "role", "link", 3, "href", "click", "keydown.enter", 4, "ngIf"], ["role", "contentinfo", 1, "challenge-info"], ["width", "16px", "height", "16px", "aria-hidden", "true", "viewBox", "0 0 24 24", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 1, "svg-icon", "svg-icon-coupon-carousel-tick-mark"], ["id", "Symbols", "stroke-width", "1", "fill-rule", "evenodd"], ["id", "Icons-/-Universal-/-Check-/-Gray"], ["id", "GreenCheck", "points", "19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236"], [1, "status", 3, "ngStyle"], ["class", "behaviour-link body-text-xs ml-2", 4, "ngIf"], [1, "behaviour-link", "body-text-xs", "ml-2"]], template: function LoyaltyCardActionButtonsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoyaltyCardActionButtonsComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.cardType === "coupon");
        } }, dependencies: [i1.NgIf, i1.NgStyle] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyCardActionButtonsComponent, [{
        type: Component,
        args: [{ selector: "loyalty-card-action-buttons", template: "<ng-container *ngIf=\"cardType === 'coupon'\">\n    <ng-container *ngIf=\"!isBehaviourOrContinuityCoupon(data)\">\n        <button *ngIf=\"data.status == 'U'\" type=\"button\" class=\"btn btn-md btn-primary w-100 p-0\" [attr.aria-describedby]=\"\n          'coupon-price-' +\n          data.offerId +\n          ' ' +\n          'coupon-title-' +\n          data.offerId +\n          ' ' +\n          'coupon-description-' +\n          data.offerId\n        \" (click)=\"clipCoupon(data)\" id=\"couponAddBtn{{ data.offerId }}\">\n            {{\n            data?.deleted\n            ? behavioralOfferAttrs &&\n            behavioralOfferAttrs?.addToMyListBtnText\n            ? behavioralOfferAttrs?.addToMyListBtnText\n            : \"Add to List\"\n            : \"Clip Coupon\"\n            }}\n        </button>\n        <div *ngIf=\"data.status == 'C' && !data?.deleted\">\n            <div class=\"clipped\" [attr.aria-describedby]=\"\n            'coupon-price-' +\n            data.offerId +\n            ' ' +\n            'coupon-title-' +\n            data.offerId +\n            ' ' +\n            'coupon-description-' +\n            data.offerId\n          \">\n                <span class=\"clipped__checkmark svg-checkmark\"></span>\n                <span class=\"clipped__label\"><span class=\"sr-only\">Coupon has already been </span>Clipped</span>\n            </div>\n        </div>\n        <button *ngIf=\"data.status == 'C' && data?.deleted\" type=\"button\" class=\"btn btn-md btn-primary w-100 p-0\" [attr.aria-describedby]=\"\n          'coupon-price-' +\n          data.offerId +\n          ' ' +\n          'coupon-title-' +\n          data.offerId +\n          ' ' +\n          'coupon-description-' +\n          data.offerId\n        \" (click)=\"clipCoupon(data)\" id=\"couponAddBtn{{ data.offerId }}\">\n            {{\n            data?.deleted\n            ? behavioralOfferAttrs &&\n            behavioralOfferAttrs?.addToMyListBtnText\n            ? behavioralOfferAttrs?.addToMyListBtnText\n            : \"Add to List\"\n            : \"Clip Coupon\"\n            }}\n        </button>\n    </ng-container>\n    <ng-container *ngIf=\"isBehaviourOrContinuityCoupon(data)\">\n        <ng-container *ngIf=\"!isCouponClipped\">\n            <button type=\"button\" class=\"btn btn-md btn-primary w-100 p-0\" [attr.aria-describedby]=\"'coupon-price-' +\n            data.offerId +\n            ' ' +\n            'coupon-title-' +\n            data.offerId +\n            ' ' +\n            'coupon-description-' +\n            data.offerId\n          \" (click)=\"clipCoupon(data)\" id=\"couponAddBtn{{ data.offerId }}\">{{\n            data?.deleted\n            ? behavioralOfferAttrs &&\n            behavioralOfferAttrs?.addToMyListBtnText\n            ? behavioralOfferAttrs?.addToMyListBtnText\n            : \"Add to List\"\n            : startChallengeLabel\n            }}</button>\n        </ng-container>\n        <ng-container *ngIf=\"isCouponClipped\">\n            <ng-container *ngIf=\"!isBonusPathCompleted\">\n                <ng-container *ngIf=\"isContinuityCoupon\">\n                    <div class=\"d-flex flex-column\">\n                        <div role=\"progressbar\" class=\"progress-offer-status\">\n                            <span class=\"progress-msg\">{{\n                                offerDataDisplay(data?.continuity).prefix\n                                }}:&nbsp;</span>\n                            <span class=\"pgs-lwrlmt\">{{\n                                offerDataDisplay(data?.continuity).progressVal\n                                }}&nbsp;</span>\n                            <span class=\"limit-separator\">/&nbsp;</span>\n                            <span class=\"pgs-uprlmt\">{{\n                                offerDataDisplay(data?.continuity).targetVal\n                                }}&nbsp;</span>\n                        </div>\n                        <div class=\"progress\" style=\"height: 6px;\">\n                            <div class=\"progress-bar\" role=\"progressbar\" [style]=\"getStyle(data)\" attr.aria-valuenow=\"{{ data?.continuity.progressValue }}\" aria-valuemin=\"0\" attr.aria-valuemax=\"{{ data?.continuity.targetValue }}\"></div>\n                        </div>\n                        <span *ngIf=\"isFreshpassContinuityCoupon(data)\"\n                            class=\"behaviour-link body-text-xs \">\n                            <a role=\"link\" href={{behavioralOfferAttrs.startShoppingLink}}\n                                class=\"links__action links__action__inline underline\"\n                                (click)=\"navigateTo(behavioralOfferAttrs.startShoppingLink)\"\n                                (keydown.enter)=\"navigateTo(behavioralOfferAttrs.startShoppingLink)\">{{behavioralOfferAttrs.startShoppingText}}</a>\n                        </span>\n                    </div>\n                </ng-container>\n                <ng-container *ngIf=\"isBehaviorCoupon\">\n                    <div class=\"progress-behaviour-status d-flex flex-column\">\n                        <span class=\"body-text-xs\">{{ behavioralOfferAttrs?.inProgressStatusText }}</span>\n                        <span class=\"behaviour-link-container\">\n                            <span class=\"behaviour-link body-text-xs\">\n                                <a class=\"links__action links__action__inline underline\" *ngIf=\"\n                                        data?.qualificationBehavior.trim().toLowerCase() ===\n                                        behavioralOfferAttrs?.grClipTextOMS.trim().toLowerCase()\n                                    \" (click)=\"navigateTo(behavioralOfferAttrs.grClipLink)\"\n                                    (keydown.enter)=\"navigateTo(behavioralOfferAttrs.grClipLink)\" role=\"link\"\n                                    href={{behavioralOfferAttrs.grClipLink}}>{{ behavioralOfferAttrs?.grClipButtonText\n                                    }}</a>\n                                <a class=\"links__action links__action__inline underline\" *ngIf=\"\n                                        data?.qualificationBehavior.trim().toLowerCase() ===\n                                        behavioralOfferAttrs?.ucaEmailOptInTextOMS.trim().toLowerCase()\n                                    \" (click)=\"navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)\"\n                                    (keydown.enter)=\"navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)\" role=\"link\"\n                                    href={{behavioralOfferAttrs.ucaEmailOptInLink}}>{{\n                                    behavioralOfferAttrs?.ucaEmailOptInButtonText }}</a>\n                                <a class=\"links__action links__action__inline underline\" *ngIf=\"\n                                        data?.qualificationBehavior.trim().toLowerCase() === behavioralOfferAttrs?.ecomFulfillmentTextOMS.trim().toLowerCase()\n                                    \" (click)=\"navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)\"\n                                    (keydown.enter)=\"navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)\" role=\"link\"\n                                    href={{behavioralOfferAttrs.ecomFulfillmentLink}}>{{\n                                    behavioralOfferAttrs?.ecomFulfillmentButtonText }}</a>\n                            </span>\n                        </span>\n                    </div>\n                </ng-container>\n            </ng-container>\n            <ng-container *ngIf=\"isBonusPathCompleted\">\n                <div role=\"contentinfo\" class=\"challenge-info\">\n                    <span [attr.aria-describedby]=\"challengeCompletedLabel\">\n                        <svg width=\"16px\" height=\"16px\" class=\"svg-icon svg-icon-coupon-carousel-tick-mark\"\n                            aria-hidden=\"true\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n                            xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                            <g id=\"Symbols\" stroke-width=\"1\" fill-rule=\"evenodd\">\n                                <g id=\"Icons-/-Universal-/-Check-/-Gray\" attr.fill=\"{{ challengeCompletedLabelColor }}\">\n                                    <polygon id=\"GreenCheck\"\n                                        points=\"19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236\">\n                                    </polygon>\n                                </g>\n                            </g>\n                        </svg>\n                    </span>\n                    <span class=\"status\" [ngStyle]=\"{\n                            color: challengeCompletedLabelColor,\n                            fontSize: fontSize\n                        }\">{{ challengeCompletedLabel }}</span>\n                </div>\n                <div *ngIf=\"!isFreshpassContinuityCoupon(data)\"\n                    class=\"behaviour-link body-text-xs ml-2\">\n                    <a role=\"link\" href={{behavioralOfferAttrs.myListLink}}\n                        class=\"links__action links__action__inline underline\"\n                        (click)=\"navigateTo(behavioralOfferAttrs.myListLink)\"\n                        (keydown.enter)=\"navigateTo(behavioralOfferAttrs.myListLink)\">{{behavioralOfferAttrs.viewInMyListText}}</a>\n                </div>\n                <div *ngIf=\"isFreshpassContinuityCoupon(data)\"\n                    class=\"behaviour-link body-text-xs ml-2\">\n                    <a role=\"link\" href={{behavioralOfferAttrs.freshPassOfferLink}}\n                        class=\"links__action links__action__inline underline\"\n                        (click)=\"navigateTo(behavioralOfferAttrs.freshPassOfferLink)\"\n                        (keydown.enter)=\"navigateTo(behavioralOfferAttrs.freshPassOfferLink)\">{{behavioralOfferAttrs.freshPassOfferText}}</a>\n                </div>\n            </ng-container>\n        </ng-container>\n    </ng-container>\n</ng-container>" }]
    }], () => [], { cardType: [{
            type: Input
        }], data: [{
            type: Input
        }], emitClippedCoupon: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoyaltyCardActionButtonsComponent, { className: "LoyaltyCardActionButtonsComponent", filePath: "loyalty-card-al-v1/loyalty-card-action-buttons/loyalty-card-action-buttons.component.ts", lineNumber: 71 }); })();

const _c0 = a0 => ({ "in-store-price-visible": a0 });
function LoyaltyCardAlV1Component_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("src", ctx_r0.logoProps[ctx_r0.cardProps == null ? null : ctx_r0.cardProps.iconImage].logo, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", ctx_r0.logoProps[ctx_r0.cardProps == null ? null : ctx_r0.cardProps.iconImage].altText);
    i0.ɵɵattribute("aria-label", ctx_r0.logoProps[ctx_r0.cardProps == null ? null : ctx_r0.cardProps.iconImage].altText);
} }
function LoyaltyCardAlV1Component_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LoyaltyCardAlV1Component_div_3_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.logoProps && (ctx_r0.cardProps == null ? null : ctx_r0.cardProps.iconImage) && (ctx_r0.cardProps == null ? null : ctx_r0.cardProps.iconImage) !== "");
} }
function LoyaltyCardAlV1Component_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "coupon-price-", ctx_r0._cardData.offerId, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r0._cardData.regularPrice && ctx_r0._cardData.regularPrice != ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("In-store: $", ctx_r0._cardData.regularPrice, "");
} }
class LoyaltyCardAlV1Component {
    constructor(_http, sanitized, j4uV1Service, commonService, _elementRef, _productUtilService, _carouselService) {
        this._http = _http;
        this.sanitized = sanitized;
        this.j4uV1Service = j4uV1Service;
        this.commonService = commonService;
        this._elementRef = _elementRef;
        this._productUtilService = _productUtilService;
        this._carouselService = _carouselService;
        this.cardProps = {};
        this.cardType = "";
        this.couponDisplayFormat = '';
        this.logoProps = {};
        this.couponToFocusOn = new EventEmitter();
        this.openRightFlyoutEvent = new EventEmitter();
        this.refreshTitleEvent = new EventEmitter();
        this.refreshSlickCarousel = new EventEmitter();
        this.href = '';
        this.showBoxtop = false;
        this.modalAttrName = 'modal';
        this.modalIdName = 'boxtop-modal-cc';
        this.showLoadingCoupon = false;
        this.offerCompleted = false;
        this.isLastOrFirstCardOfPreviousOrNextSet = false;
        this.isFirstCardOfNextSet = false;
        this.configObj = {
            programType: '',
            appName: ''
        };
        this.sm = '575px';
        this.md = '768px';
        this.imagePath = window['AB']['dMTProductCard'];
    }
    ngOnInit() {
        if (!this.isLoyaltyCardCarouselRedesignDisabled) {
            this.subscribeForAdaFocusEvent();
        }
        this.j4uV1Service.couponUpdated.subscribe((update) => {
            if (this.cardData.offerId == update.id && this.cardType === 'coupon') {
                this.cardData.status = update.status;
                this.cardData.deleted = update.deleted;
                this.cardData = { ...this.cardData, ...update };
                this._cardData = { ...this.cardData };
            }
        });
        this.couponDetailPath = window['AB'].isWWW ? this.commonService.getCouponDetailPathWww() : this.commonService.getCouponDetailPathShop();
        this.checkFilterSource();
        if (this.couponDisplayFormat === 'grid' && this.configObj.appName !== 'weeklyAdPzn') {
            this.updateOfferDetailsLink();
        }
        if (this.couponDisplayFormat === 'carousel' && this.configObj?.appName === 'FreshPass' && this.configObj?.programType?.toUpperCase().trim() === 'FRESHPASS LTO') {
            this.updateOfferDetailsLink();
        }
    }
    ngOnChanges(changes) {
        this.transformIntoLoyaltyCardProps();
        if (changes && changes.cardType && changes.cardType.currentValue !== changes.cardType.previousValue) {
            this.transformIntoLoyaltyCardProps();
        }
    }
    ngAfterViewInit() {
        if (this.couponDisplayFormat === 'grid' && this.configObj.appName !== 'weeklyAdPzn') {
            const getOfferDetailsId = (document.getElementById(`cardOfferDetails_${this.cardIndex}`));
            getOfferDetailsId.setAttribute('href', `/foru/offer-details.${this._cardData.offerId}.${this._cardData.offerTs}.${this._cardData.offerPgm}.html`);
        }
    }
    updateOfferDetailsLink() {
        setTimeout(() => {
            const getOfferDetailsId = (document.getElementById(`cardOfferDetails_${this.cardIndex}`));
            getOfferDetailsId.setAttribute('href', `/foru/offer-details.${this._cardData.offerId}.${this._cardData.offerTs}.${this._cardData.offerPgm}.html`);
        }, 1000);
    }
    checkFilterSource() {
        if (this.filterSource === 'pdp') {
            let upc = '';
            let itemId = '';
            const productDetailElem = (document.getElementsByTagName('product-detail'));
            if (window['AB']['catalogServiceSubscriptionKey'] && window['AB']['catalogServiceEnable'] == true) {
                upc = productDetailElem && productDetailElem[0] && productDetailElem[0].getAttribute('data-product-upc');
                /// upc
            }
            else {
                itemId = productDetailElem && productDetailElem[0] && productDetailElem[0].getAttribute('data-product-id');
                ///itemId
            }
            this.commonService.currentCartObj.subscribe((data) => {
                this.offerCompleted = false;
                if (data && data.cartItems && data.cartItems.length > 0) {
                    data.cartItems.forEach(product => {
                        if (product.upc === upc || product.itemId === itemId) {
                            const clippedCouponsByUpc = this.commonService.getClippedCouponByUpc(product['upc']);
                            if (clippedCouponsByUpc.totalCoupons > 0) {
                                product['arrCoupon'] = clippedCouponsByUpc.clippedCoupons;
                                product['totalCoupons'] = clippedCouponsByUpc.totalCoupons;
                                product['totalClippedCoupons'] = clippedCouponsByUpc.totalClippedCoupons;
                            }
                            if (product.arrCoupon && product.arrCoupon.length > 0) {
                                product.arrCoupon.forEach(coupon => {
                                    if (coupon.offerId === this._cardData.offerId) {
                                        this.offerCompleted = coupon.offerComplete;
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    }
    subscribeForAdaFocusEvent() {
        this.slickChangesSubscription = this._carouselService.slickChanges$.subscribe(() => {
            const parentSlickElemContainer = this._elementRef?.nativeElement?.closest('.slick-slide');
            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), span[role="button"], a[role="button"], img[role="button"], a';
            const firstFocusableElement = parentSlickElemContainer.querySelectorAll(focusableElements)[0];
            const focusableContent = parentSlickElemContainer.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];
            if (window.innerWidth < 768) {
                setTimeout(() => {
                    focusableContent.forEach((element) => {
                        element.setAttribute('tabindex', '0');
                        element.setAttribute('aria-hidden', 'false');
                    });
                    parentSlickElemContainer.removeAttribute('tabindex');
                    parentSlickElemContainer.removeAttribute('aria-hidden');
                    if (!parentSlickElemContainer?.classList?.contains('slick-active') && (parentSlickElemContainer?.nextElementSibling?.classList?.contains('slick-active') || parentSlickElemContainer?.previousElementSibling?.classList?.contains('slick-active'))) {
                        //const parentSlickElemContainer = this._elementRef?.nativeElement?.closest('.slick-slide');
                        const isFirstCardOfThisNextSet = this.isFirstCardOfNextSet = (parentSlickElemContainer?.previousElementSibling?.classList?.contains('slick-active'));
                        // add all the elements inside modal which you want to make focusable
                        const callBackFn = function (e) {
                            if (isFirstCardOfThisNextSet) {
                                $(parentSlickElemContainer).closest('#carousel-coupons').slick('slickNext');
                            }
                            else {
                                $(parentSlickElemContainer).closest('#carousel-coupons').slick('slickPrev');
                            }
                        };
                        $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().on('focus', callBackFn);
                        this.isLastOrFirstCardOfPreviousOrNextSet = true;
                    }
                    else if (this.isLastOrFirstCardOfPreviousOrNextSet) {
                        $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().off('focus');
                        this.isLastOrFirstCardOfPreviousOrNextSet = false;
                    }
                }, 100);
            }
            else if (this.isLastOrFirstCardOfPreviousOrNextSet) {
                $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().off('focus');
            }
        });
    }
    onClickOfDetails(drawerType) {
        if (this.couponDisplayFormat !== 'grid' || this.configObj.appName === 'weeklyAdPzn') {
            let ObjDrawerData = {};
            if (drawerType === 'offer-detail') {
                if (this.filterSource === 'pdp') {
                    const productDetailElem = (document.getElementsByTagName('product-detail'));
                    const productDetailsWrapperElem = (document.getElementsByClassName('product-details-wrapper'));
                    let id = '';
                    if (productDetailElem.length) {
                        id = productDetailElem[0].getAttribute('data-product-id');
                    }
                    else if (productDetailsWrapperElem.length) {
                        id = productDetailsWrapperElem[0].getAttribute('data-bpn');
                    }
                    const product = { id };
                    ObjDrawerData = {
                        type: drawerType,
                        coupon: this._cardData,
                        product: product,
                        triggeredElement: 'coupon-carousel-pdp'
                    };
                }
                else {
                    ObjDrawerData = {
                        type: drawerType,
                        coupon: this._cardData,
                        product: {},
                        triggeredElement: 'coupon-carousel'
                    };
                }
                this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this._cardData.brand);
                window['digitalData'].coupon = {
                    carouselSection: 'offer-drawer'
                };
            }
            if (this.configObj.appName === 'weeklyAdPzn') {
                this.openRightFlyoutEvent.emit({});
            }
            ObjDrawerData = { ...ObjDrawerData, configObj: this.configObj };
            setTimeout(() => this.commonService.rightDrawerSource.next(ObjDrawerData), 100);
        }
    }
    _updateAnalyticsLinkClick(offerType, offerName) {
        if (offerName) {
            window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
        }
        else {
            window['AB']['DATALAYER'].setLinkClickEvents(offerType);
        }
    }
    _updateAnalyticsCarouselName() {
        if (window['AB']['DATALAYER'] && this.carouselSection) {
            window['AB']['DATALAYER'].setCarouselName('coupons|' + this.carouselSection);
        }
    }
    setCookie(name, value) {
        document.cookie = `${name}=${value}; max-age=600; path=/; domain=${window['AB']['userInfo']['banner']}.com`;
    }
    clipCoupon(coupon) {
        if (this._isRegistered()) {
            if (window["SWY"]["ENFORCEMENT"].isTokenActive()) {
                this.showBoxTopModal(coupon);
                this.j4uClipCoupon(coupon);
                if (this.couponDisplayFormat === 'carousel') {
                    this._updateAnalyticsCarouselName();
                }
            }
            else if (window["SWY"]["ENFORCEMENT"].checkAuthorizedCookie()) {
                this._http.get(window["AB"]["userInfoPath"]).subscribe((data) => {
                    window["AB"]["userInfo"].updateTokenRefreshProperty();
                    this.showBoxTopModal(coupon);
                    this.j4uClipCoupon(coupon);
                    if (this.couponDisplayFormat === 'carousel') {
                        this._updateAnalyticsCarouselName();
                    }
                }, (error) => {
                    const strError = "Coupon Clip - Soft Token is not expired, but AEM servlet returns " +
                        error.status +
                        "status. Redirects to 500 error message";
                    window["AB"]["DATALAYER"].setError(coupon.offerId.toString(), "coupon clipping", strError);
                    setTimeout(function () {
                        window["AB"]["COMMON"].redirectErrorPage();
                    }, 500);
                });
            }
            else {
                const strError = "Coupon Clip - Session is expired, reloading the page";
                window["AB"]["DATALAYER"].setError(coupon.offerId.toString(), "coupon clipping", strError);
                setTimeout(function () {
                    window.location.reload();
                }, 500);
            }
        }
        else {
            if (this.configObj.appName === 'weeklyAdPzn') {
                const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
                this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));
                const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
                const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('clip-coupon', navPath) || '';
                window.location.assign(navPath + `${analyticsIcmpid}`);
                return;
            }
            else if (!this.showBoxTopModal(coupon)) {
                window["AB"]["COMMON"].showSignInModal_OTP(window.location.href);
                const elemCreateAccountModalJ4u = (document.getElementById('createAccountModalj4u'));
                if (elemCreateAccountModalJ4u)
                    elemCreateAccountModalJ4u.setAttribute('data-value', `couponAddBtn${coupon.offerId}`);
            }
        }
    }
    showBoxTopModal(coupon) {
        let result = false;
        if (window["AB"].isWWW) {
            if (localStorage.showBoxtop) {
                this.showBoxtop = JSON.parse(localStorage.getItem("showBoxtop"));
            }
            if (window["AB"].userInfo.boxTopAuth) {
                this.showBoxtop = false;
            }
            if (coupon["offerSubPgm"] === "07" && this.showBoxtop) {
                result = true;
                // if ($(this.modalIdName) && $(this.modalIdName).model != undefined) {
                //     $(this.modalIdName).modal({ 'show': true });
                // }
            }
        }
        return result;
    }
    j4uClipCoupon(coupon) {
        this.showLoadingCoupon = true;
        const storeId = window["AB"]["userInfo"]["j4u"]["storeId"];
        const analyticsData = {
            nativeElement: this._elementRef.nativeElement
        };
        this.j4uV1Service
            .clipCoupon(coupon, storeId, null, this.isP13nCoupon, analyticsData)
            .pipe(finalize(() => {
            this.showLoadingCoupon = false;
        }))
            .subscribe((response) => {
            if (response &&
                response["items"] &&
                response["items"][0] &&
                response["items"][0]["status"] === 1) {
                if (this.couponDisplayFormat === 'grid') {
                    this.couponToFocusOn.emit(this.cardIndex);
                }
                if (this.couponDisplayFormat === 'carousel') {
                    this.refreshTitleEvent.next(this._cardData);
                    this.refreshSlickCarousel.next(this.cardIndex);
                }
            }
        });
    }
    /**
     * Check if user is registered.
     */
    _isRegistered() {
        return (window["AB"]["COMMON"].sessionNotExpired() &&
            window["AB"]["COMMON"].authorize());
    }
    getImageUrl(viewport, coupon) {
        const modifiedImagePath = this.imagePath || '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available';
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', coupon.imageId).replace('${viewport}', viewport) : '';
    }
    transformIntoLoyaltyCardProps() {
        const coupon = {};
        coupon.brand = this.cardData.brand ? this.cardData.brand : (this.cardData.name) ? this.cardData.name : '';
        coupon.brand = this.cardData.brand + '.';
        coupon.refineDescription = this.cardData.description;
        coupon.refineEndDate = this.dateConversion(this.cardData.endDate);
        coupon.offerId = this.cardData.offerId ? this.cardData.offerId : this.cardData.couponID;
        coupon.usageTypeTxt = window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[this.cardData.usageType];
        coupon.offerPgmLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponTypes[this.cardData.offerPgm];
        // this.clipLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CL'];
        coupon.status = (this.cardData.deleted) ? 'U' : this.cardData.status;
        coupon.offerType = (this.cardData.offerType) ? this.cardData.offerType : this.cardData.offerPgm;
        this.cardProps.cardHeader = this.getCardHeader();
        this.cardProps.cardTitle = coupon.brand;
        this.cardProps.cardDescription = coupon.refineDescription;
        this.cardProps.cardLinkText = 'Offer Details';
        this.cardProps.cardLinkAriaDescribedByText = `coupon-price-${this.cardData.offerId} coupon-title-${this.cardData.offerId} coupon-description-${this.cardData.offerId}`;
        this.cardProps['cardImage'] = this.sanitized.bypassSecurityTrustHtml(`<picture>
                                <source media="(min-width: ${this.md})" srcset="${this.getImageUrl('desktop', this.cardData)}">
                                <source media="(min-width: ${this.sm})" srcset="${this.getImageUrl('tablet', this.cardData)}">
                                <img loading="lazy" class="w-100 img-responsive" role="presentation" src="${this.getImageUrl('mobile', this.cardData)}" attr.aria-label="${this.cardData.brand}" alt="${this.cardData.brand}"/>
                            </picture>`);
        // cardProps.cardActionButtons = this.getCardActionButtonsTemplate(coupon);
        this.cardProps.cardExpirySection = `<span class="text-truncate expiration align-self-start pl-0">${coupon.usageTypeTxt}</span><span class="text-nowrap expiration align-self-start pl-0" attr.aria-label="Expires {{ ${this.cardData.endDate} | date: 'longDate' }}">Expires ${coupon.refineEndDate}</span>`;
        this.cardProps['iconImage'] = this.getIconImage();
        this._cardData = { ...coupon, ...this.cardData };
    }
    ;
    dateConversion(dateServer) {
        const dateStr = dateServer;
        const regex = /\d+/;
        const mills = regex.exec(dateStr);
        const d = new Date(parseInt(mills[0]));
        d.setUTCMilliseconds(mills.index);
        const dateOutput = d.toLocaleDateString('en-US');
        return dateOutput;
    }
    ;
    getCardHeader() {
        let cardHeader = '';
        if (this.cardData?.forUDescription) {
            return this.cardData.forUDescription;
        }
        if (this.cardData && this.cardData['offerPrice'] && this.cardData['offerPrice'] !== '') {
            cardHeader = this.cardData['offerPrice'];
        }
        if (this.cardData && this.cardData['priceTitle']) {
            cardHeader = this.cardData['priceTitle'] + ' ' + cardHeader;
        }
        return cardHeader;
    }
    getIconImage() {
        let iconImage = 'LastBeforeDefaultIconImage';
        const rewardProtoTypes = ['REWARDS_FLAT', 'REWARDS_ACCUMULATION'];
        const freshPassCouponEventListener = ["freshpass credit", "freshpass perks", "freshpass deals"];
        const events = this.cardData && this.cardData['hierarchies'] && this.cardData['hierarchies']['events'];
        let freshPassExist = false;
        for (let i in events) {
            if ((freshPassCouponEventListener.map(e => e.toLowerCase())).indexOf(events[i].toLowerCase()) !== -1) {
                freshPassExist = true;
            }
            else {
                freshPassExist = false;
                break;
            }
        }
        if (freshPassExist) {
            iconImage = "FreshPassIconImage"; //only display freshpass logo if ALL events are freshpass event
        }
        ;
        if (((this.cardData.offerProgramType && rewardProtoTypes.includes(this.cardData.offerProgramType)) || (this.cardData.offerProtoType && rewardProtoTypes.includes(this.cardData.offerProtoType)))) {
            iconImage = 'RewardsIconImage';
        }
        ;
        if (this.configObj?.appName === 'FreshPass') {
            //starts only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
            const freshpassProgramType = ["FRESHPASS", "FRESHPASS LTO"];
            const programType = this.cardData?.programType ?? "";
            iconImage = freshpassProgramType.includes(programType) ? "FreshPassIconImage" : "LastBeforeDefaultIconImage";
            //ends only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
        }
        return iconImage;
    }
    ngOnDestroy() {
        if (this.slickChangesSubscription) {
            this.slickChangesSubscription.unsubscribe();
        }
    }
    static { this.ɵfac = function LoyaltyCardAlV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyCardAlV1Component)(i0.ɵɵdirectiveInject(i1$1.HttpClient), i0.ɵɵdirectiveInject(i2.DomSanitizer), i0.ɵɵdirectiveInject(i3.J4uV1Service), i0.ɵɵdirectiveInject(i3.CommonService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.ProductUtilService), i0.ɵɵdirectiveInject(i3.LoyaltyCarouselService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoyaltyCardAlV1Component, selectors: [["loyalty-card-al-v1"]], inputs: { cardType: "cardType", couponDisplayFormat: "couponDisplayFormat", cardData: "cardData", cardIndex: "cardIndex", logoProps: "logoProps", filterSource: "filterSource", carouselSection: "carouselSection", couponsCarouselItem: "couponsCarouselItem", isP13nCoupon: "isP13nCoupon", isLoyaltyCardCarouselRedesignDisabled: "isLoyaltyCardCarouselRedesignDisabled", configObj: "configObj" }, outputs: { couponToFocusOn: "couponToFocusOn", openRightFlyoutEvent: "openRightFlyoutEvent", refreshTitleEvent: "refreshTitleEvent", refreshSlickCarousel: "refreshSlickCarousel" }, features: [i0.ɵɵProvidersFeature([DatePipe]), i0.ɵɵNgOnChangesFeature], decls: 22, vars: 17, consts: [["role", "region", 1, "coupon-card", "card", "mr-auto", "ml-auto", "ml-md-0", 3, "ngClass"], [1, "coupon-card__card-body"], [1, "coupon-card__card-body__card-title"], [4, "ngIf"], [1, "coupon-card__card-body__card-title__price"], ["class", "row cpn-details font-weight-bold ml-4 pl-1 pb-1 text-truncate", 3, "id", "ngClass", 4, "ngIf"], [1, "row"], [1, "col-8"], [1, "cpn-title", "mb-0", 3, "ngClass"], [1, "cpn-details"], [1, "coupon-card-offer-details-container"], ["role", "link", 1, "coupon-card-offer-details", "offer-details", 3, "click", "keyup.enter", "id"], ["role", "img", "aria-label", "Coupon image", 1, "col-4", 3, "innerHTML"], [1, "cpn-flex-area", "d-flex", "w-100", 3, "ngClass"], [1, "w-50"], [3, "emitClippedCoupon", "cardType", "data"], ["role", "contentinfo", 1, "d-flex", "flex-column", 2, "right", "16px", "position", "absolute", 3, "innerHTML"], [1, "svg-icon", "just-for-you-16px", "icon-position", 3, "src", "alt"], [1, "row", "cpn-details", "font-weight-bold", "ml-4", "pl-1", "pb-1", "text-truncate", 3, "id", "ngClass"]], template: function LoyaltyCardAlV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, LoyaltyCardAlV1Component_div_3_Template, 2, 1, "div", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, LoyaltyCardAlV1Component_div_6_Template, 2, 6, "div", 5);
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "h5", 8);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 10)(14, "a", 11);
            i0.ɵɵlistener("click", function LoyaltyCardAlV1Component_Template_a_click_14_listener() { return ctx.onClickOfDetails("offer-detail"); })("keyup.enter", function LoyaltyCardAlV1Component_Template_a_keyup_enter_14_listener() { return ctx.onClickOfDetails("offer-detail"); });
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(16, "div", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "div", 13)(18, "div", 14)(19, "loyalty-card-action-buttons", 15);
            i0.ɵɵlistener("emitClippedCoupon", function LoyaltyCardAlV1Component_Template_loyalty_card_action_buttons_emitClippedCoupon_19_listener($event) { return ctx.clipCoupon($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 14);
            i0.ɵɵelement(21, "div", 16);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.couponDisplayFormat === "grid" ? "mw-100" : "");
            i0.ɵɵattribute("aria-label", ctx.cardProps == null ? null : ctx.cardProps.cardAriaLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.cardType === "coupon");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.cardProps == null ? null : ctx.cardProps.cardHeader, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx._cardData.regularPrice && ctx.couponDisplayFormat === "grid");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", ctx.couponDisplayFormat === "grid" ? "d-block text-truncate" : "");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.cardProps == null ? null : ctx.cardProps.cardTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.cardProps == null ? null : ctx.cardProps.cardDescription, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("id", "cardOfferDetails_", ctx.cardIndex, "");
            i0.ɵɵattribute("aria-describedby", ctx.cardProps == null ? null : ctx.cardProps.cardLinkAriaDescribedByText);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.cardProps == null ? null : ctx.cardProps.cardLinkText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.cardProps == null ? null : ctx.cardProps.cardImage, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.couponDisplayFormat === "grid" ? "flex-nowrap" : "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cardType", ctx.cardType)("data", ctx._cardData);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", ctx.cardProps == null ? null : ctx.cardProps.cardExpirySection, i0.ɵɵsanitizeHtml);
        } }, dependencies: [i1.NgClass, i1.NgIf, LoyaltyCardActionButtonsComponent] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyCardAlV1Component, [{
        type: Component,
        args: [{ selector: "loyalty-card-al-v1", providers: [DatePipe], template: "<div class=\"coupon-card card mr-auto ml-auto ml-md-0\" [ngClass]=\"couponDisplayFormat === 'grid' ? 'mw-100' : ''\" role=\"region\" attr.aria-label=\"{{cardProps?.cardAriaLabel}}\">\n    <div class=\"coupon-card__card-body\">\n\n        <div class=\"coupon-card__card-body__card-title\">\n            <div *ngIf=\"cardType === 'coupon'\">\n                <div *ngIf=\"logoProps && cardProps?.iconImage && cardProps?.iconImage !== ''\">\n                    <img src='{{logoProps[cardProps?.iconImage].logo}}'\n                            class=\"svg-icon just-for-you-16px icon-position\" \n                            alt='{{logoProps[cardProps?.iconImage].altText}}' attr.aria-label='{{logoProps[cardProps?.iconImage].altText}}'>\n                </div>\n            </div>\n            <div class=\"coupon-card__card-body__card-title__price\">\n                {{cardProps?.cardHeader}}\n            </div>\n        </div>\n        <div class=\"row cpn-details font-weight-bold ml-4 pl-1 pb-1 text-truncate\" id=\"coupon-price-{{_cardData.offerId}}\" *ngIf=\"_cardData.regularPrice && couponDisplayFormat === 'grid'\" [ngClass]=\"{'in-store-price-visible' : _cardData.regularPrice && _cardData.regularPrice != ''}\">In-store: ${{_cardData.regularPrice}}</div>\n\n        <div class=\"row\">\n            <div class=\"col-8\">\n                <h5 class=\"cpn-title mb-0\" [ngClass]=\"couponDisplayFormat === 'grid' ? 'd-block text-truncate' : ''\">{{cardProps?.cardTitle}}</h5>\n                <div class=\"cpn-details\">\n                    {{cardProps?.cardDescription}}\n                </div>\n                <div class=\"coupon-card-offer-details-container\">\n                    <a class=\"coupon-card-offer-details offer-details\" id=\"cardOfferDetails_{{cardIndex}}\"\n                        [attr.aria-describedby]=\"cardProps?.cardLinkAriaDescribedByText\"\n                        (click)=\"onClickOfDetails('offer-detail')\" (keyup.enter)=\"onClickOfDetails('offer-detail')\" role=\"link\">{{cardProps?.cardLinkText}}</a>\n                </div>\n            </div>\n            <div class=\"col-4\" [innerHTML]=\"cardProps?.cardImage\" role=\"img\" aria-label=\"Coupon image\"></div>\n        </div>\n        <div class=\"cpn-flex-area d-flex w-100\" [ngClass]=\"couponDisplayFormat === 'grid' ? 'flex-nowrap' : ''\">\n            <div class=\"w-50\">\n                <loyalty-card-action-buttons [cardType]=\"cardType\" [data]=\"_cardData\" (emitClippedCoupon)=\"clipCoupon($event)\"></loyalty-card-action-buttons>\n            </div>\n            <div class=\"w-50\">\n                <div class=\"d-flex flex-column\" [innerHTML]=\"cardProps?.cardExpirySection\" style=\"right: 16px; position: absolute;\" role=\"contentinfo\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
    }], () => [{ type: i1$1.HttpClient }, { type: i2.DomSanitizer }, { type: i3.J4uV1Service }, { type: i3.CommonService }, { type: i0.ElementRef }, { type: i3.ProductUtilService }, { type: i3.LoyaltyCarouselService }], { cardType: [{
            type: Input
        }], couponDisplayFormat: [{
            type: Input
        }], cardData: [{
            type: Input
        }], cardIndex: [{
            type: Input
        }], logoProps: [{
            type: Input
        }], filterSource: [{
            type: Input
        }], carouselSection: [{
            type: Input
        }], couponsCarouselItem: [{
            type: Input
        }], isP13nCoupon: [{
            type: Input
        }], isLoyaltyCardCarouselRedesignDisabled: [{
            type: Input
        }], couponToFocusOn: [{
            type: Output
        }], openRightFlyoutEvent: [{
            type: Output
        }], refreshTitleEvent: [{
            type: Output
        }], refreshSlickCarousel: [{
            type: Output
        }], configObj: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoyaltyCardAlV1Component, { className: "LoyaltyCardAlV1Component", filePath: "loyalty-card-al-v1/loyalty-card-al-v1.component.ts", lineNumber: 16 }); })();

class LoyaltyCardModule {
    static { this.ɵfac = function LoyaltyCardModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyCardModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoyaltyCardModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            LoyaltyCardAlV1Component
        ], imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyCardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoyaltyCardAlV1Component,
                    LoyaltyCardActionButtonsComponent
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    LoyaltyCardAlV1Component
                ],
                providers: [
                    LoyaltyCardAlV1Component
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoyaltyCardModule, { declarations: [LoyaltyCardAlV1Component,
        LoyaltyCardActionButtonsComponent], imports: [CommonModule], exports: [LoyaltyCardAlV1Component] }); })();

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { LoyaltyCardAlV1Component, LoyaltyCardModule };
